"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "AclEssentialsLogo___StyledSvg",
  componentId: "fmndat-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function AclEssentialsLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M440.302 231.041c-1.852-1.05-83.79-33.714-85.757-34.516v-92.076a19.084 19.084 0 00-9.068-16.227c-1.012-.649-95.855-48.033-96.943-48.567a19.085 19.085 0 00-17.087 0c-1.088.553-95.932 47.918-96.943 48.567a19.11 19.11 0 00-9.05 16.227v92.076c-1.985.802-83.923 33.466-85.756 34.516A19.026 19.026 0 0030 247.631v114.546c0 6.72 3.513 12.943 9.26 16.38l95.454 57.272a19.038 19.038 0 009.831 2.711c2.387 0 4.811-.42 7.083-1.336L240 401.848l88.372 35.356c2.272.916 4.696 1.336 7.083 1.336 3.417 0 6.815-.897 9.831-2.71l95.455-57.273c5.746-3.437 9.259-9.66 9.259-16.38V247.63c0-6.853-3.685-13.21-9.698-16.59zm-106.566 52.634l-50.896-20.37 54.333-32.588 50.896 20.35-54.333 32.608zm-17.372-85.031l-57.273 34.383v-69.033l57.273-28.636v63.286zm-95.455 34.364l-57.273-34.383v-63.267l57.273 28.636v69.014zm-78.082-2.31l54.333 32.588-50.896 20.389-54.333-32.607 50.896-20.37zm20.81 87.15l57.272-22.91v73.424l-57.273 22.91v-73.424zM240 78.085l52.767 26.364L240 130.852l-52.767-26.403L240 78.085zM68.182 281.365l57.272 34.364v70.025l-57.272-34.383v-70.006zm190.909 13.573l57.273 22.91v73.423l-57.273-22.909v-73.424zm95.454 90.797v-70.026l57.273-34.363v70.006l-57.272 34.383z"
  }));
}

var _default = AclEssentialsLogo;
exports["default"] = _default;